import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

// Actions
import { setUserEditing } from '../../../actions/stepsUser';
import { resetAll } from '../../../actions/global';

// Components
import RankingItem from '../RankingItem/RankingItem';

// Icons
import { Plus } from 'lucide-react';

// Images
import UsersImg from '../../../assets/images/Home/UsersImg.png';
import ChatImg from '../../../assets/images/Home/ChatImg.png';

// Kit
import { Card, Badge, Button } from '@/components/ui';

const AdviserComponent = (props) => {

    // Actions
    const { setUserEditing, resetAll, activeTask } = props;

    // External props
    const { type, array, onBoardingComplete } = props;

    const handleCreateUser = () => {
        setUserEditing({
            userEditing: false,
            userUid: ''
        });

        resetAll();
    }

    const isAdvisers = type === 'advisers';

    return (
        <Card hover className="flex h-full min-h-[350px] flex-col p-5 text-left">
            <div className="mb-3 flex items-center justify-between gap-2">
                <h2 className="text-[17px] font-bold leading-tight tracking-[-0.01em] text-foreground">
                    {isAdvisers ? 'Top Asesores' : 'Top Preguntas Frecuentes'}
                </h2>
                <Badge variant={isAdvisers ? 'brand' : 'neutral'} size="sm" className="hidden shrink-0 sm:inline-flex">
                    {isAdvisers ? 'Preguntas respondidas' : 'Total de Clicks'}
                </Badge>
            </div>
            <div className="flex flex-1 flex-col">
                {
                    array.length === 0 ?
                        isAdvisers ?
                            <div className="flex flex-1 flex-col items-center justify-center py-6 text-center">
                                <img src={UsersImg} alt="Img" className="mb-3 w-28 opacity-90" />
                                <p className="mb-4 max-w-[240px] text-sm text-muted-foreground">Creá o habilitá al menos un asesor para poder visualizar sus estadísticas.</p>
                                {(activeTask > 3 || onBoardingComplete) &&
                                    <Button asChild size="sm">
                                        <Link to='/createUser' onClick={handleCreateUser}>
                                            <Plus size={16} /> Agregar asesor
                                        </Link>
                                    </Button>}
                            </div>
                            :
                            type === 'questions' ?
                                <div className="flex flex-1 flex-col items-center justify-center py-6 text-center">
                                    <img src={ChatImg} alt="Img" className="mb-3 w-28 opacity-90" />
                                    <p className="mb-4 max-w-[240px] text-sm text-muted-foreground">Dirigite a la sección CHAT para poder configurar tus preguntas frecuentes</p>
                                    {(activeTask > 2 || onBoardingComplete) ?
                                        <Button asChild size="sm">
                                            <Link to='/chat' onClick={handleCreateUser}>Configurar chat</Link>
                                        </Button>
                                        :
                                        null
                                    }
                                </div>
                                :
                                null
                        :
                        null
                }
                {
                    (activeTask > 2 || onBoardingComplete) &&
                        <div className="flex flex-col gap-1.5">
                            {array.map((item, index) => (
                                <RankingItem
                                    key={index}
                                    type={type}
                                    rank={index + 1}
                                    {...item}
                                />
                            ))}
                        </div>
                }
                {
                    (isAdvisers && array.length <= 2 && array.length !== 0 && onBoardingComplete) ?
                        <Button asChild size="sm" variant="outline" className="mt-4 self-center">
                            <Link to='/createUser' onClick={handleCreateUser}>
                                <Plus size={16} /> Agregar asesor
                            </Link>
                        </Button>
                        :
                        null
                }
            </div>
        </Card>
    )
}

const mapStateToProps = state => {
    return {
        endTutorial: state.auth.endTutorial,
        users: state.stepsUser.users,
        activeTask: state.tasks.activeTask
    }
}

const mapDispatchToProps = dispatch => {
    return {
        setUserEditing: ({ userEditing, userUid }) => dispatch(setUserEditing({ userEditing, userUid })),
        resetAll: () => dispatch(resetAll()),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(AdviserComponent);
